import React, { PureComponent } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { buttons, selectors } from '../ducks/navigation'
import { thunks as newShareThunks } from '../ducks/newShare'
import { remixExistingShare } from '../ducks/common'

// Styled Components
import { Navigation, Icon, TooltipContainer } from './Navigation.styles'

// TODO(AM): Refactor button into its own component and use this as a composer
class NavigationComponent extends PureComponent {
    state = {
        showTooltip: false,
        tooltipContent: ''
    }

    _setTooltip = tooltipContent => () => {
        this.setState({
            showTooltip: true,
            tooltipContent
        })
    }

    _hideTooltip = () => {
        this.setState({
            showTooltip: false,
            tooltipContent: ''
        })
    }

    _isButtonDisabled = button => {
        return this.props.isButtonDisabled(button)
    }

    _onNewClick = () => {
        if (this._isButtonDisabled(buttons.new)) return

        const { createNewShare, history } = this.props

        createNewShare()
            .then(() => history.push('/'))
            .catch(() => {})
    }

    _onSaveClick = () => {
        if (this._isButtonDisabled(buttons.save)) return

        const { saveShare, history } = this.props

        saveShare()
            .then(key => history.push(`/v/${key}`))
            .catch(() => alert('Something went wrong, please try again later.'))
    }

    _onRemixClick = () => {
        if (this._isButtonDisabled(buttons.remix)) return

        const { remixExistingShare, history } = this.props

        remixExistingShare()
            .then(() => history.push('/'))
            .catch(() => {})
    }

    _onInfoClick = () => {
        if (this._isButtonDisabled(buttons.info)) return

        window.open(
            'https://khan.github.io/KaTeX/function-support.html',
            '_blank'
        )
    }

    _onTweetClick = () => {
        if (this._isButtonDisabled(buttons.tweet)) return
        console.log('You clicked tweet!')
    }

    render() {
        const { showTooltip, tooltipContent } = this.state

        return (
            <Navigation onMouseLeave={this._hideTooltip}>
                <div
                    onMouseEnter={this._setTooltip('new')}
                    onClick={this._onNewClick}
                >
                    <Icon
                        path="/icons/file-plus.svg"
                        disabled={this._isButtonDisabled(buttons.new)}
                    />
                </div>

                <div
                    onMouseEnter={this._setTooltip('save')}
                    onClick={this._onSaveClick}
                >
                    <Icon
                        path="/icons/save.svg"
                        disabled={this._isButtonDisabled(buttons.save)}
                    />
                </div>

                <div
                    onMouseEnter={this._setTooltip('fork')}
                    onClick={this._onRemixClick}
                >
                    <Icon
                        path="/icons/shuffle.svg"
                        disabled={this._isButtonDisabled(buttons.remix)}
                    />
                </div>

                <div
                    onMouseEnter={this._setTooltip('info')}
                    onClick={this._onInfoClick}
                >
                    <Icon
                        path="/icons/info.svg"
                        disabled={this._isButtonDisabled(buttons.info)}
                    />
                </div>

                <div
                    onMouseEnter={this._setTooltip('tweet')}
                    onClick={this._onTweetClick}
                >
                    <Icon
                        path="/icons/twitter.svg"
                        disabled={this._isButtonDisabled(buttons.tweet)}
                    />
                </div>

                {showTooltip && (
                    <TooltipContainer>{tooltipContent}</TooltipContainer>
                )}
            </Navigation>
        )
    }
}

export default compose(
    connect(
        state => ({
            isButtonDisabled: selectors.isButtonDisabled(state.navigation)
        }),
        dispatch => {
            return {
                createNewShare: katexCode =>
                    dispatch(newShareThunks.createNewShare(katexCode)),
                saveShare: () => dispatch(newShareThunks.saveShare()),
                remixExistingShare: () => dispatch(remixExistingShare())
            }
        }
    ),
    withRouter
)(NavigationComponent)



// WEBPACK FOOTER //
// ./src/components/Navigation.js